"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

require("intl");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxAsyncConnect = require("redux-async-connect");

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _cookie = require("cookie");

var _cookie2 = _interopRequireDefault(_cookie);

var _components = require("../../components");

var _LanguageDropdown = require("./../../components/LanguageDropdown/LanguageDropdown");

var _HelpButton = require("./../../components/HelpButton/HelpButton");

var _Language = require("../../helpers/Language");

var _ImageRetriever = require("../../helpers/ImageRetriever");

var _PopupType = require("../../helpers/PopupType");

var _Product = require("../../helpers/Product");

var _Location = require("../../helpers/Location");

var _NeutralBrandingRoutes = require("../../helpers/NeutralBrandingRoutes");

var _auth = require("../../redux/modules/auth");

var _popup = require("../../redux/modules/popup");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

var _App = require("./App.scss");

var _App2 = _interopRequireDefault(_App);

var _stingray_logo_horizontal_white = require("../../../res/images/logo/stingray_logo_horizontal_white.svg");

var _stingray_logo_horizontal_white2 = _interopRequireDefault(_stingray_logo_horizontal_white);

var _logo_stingray = require("../../../res/images/logo/logo_stingray.svg");

var _logo_stingray2 = _interopRequireDefault(_logo_stingray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    var globalState = getState();

    if ((0, _auth.canLoad)(globalState)) {
      promises.push(dispatch((0, _auth.load)()));
    }

    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    lang: state.auth.lang,
    type: state.popup.type
  };
}, { changePopupType: _popup.changePopupType, setUtmParameters: _auth.setUtmParameters, setLocation: _auth.setLocation, pushState: _reactRouterRedux.push }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.auth.productName) {
        var cookieJson = _cookie2.default.parse(document.cookie);
        var utmParameters = cookieJson["" + _config2.default.envPrefix + this.props.auth.productName.toLowerCase() + "_utmparameters"];
        this.props.setUtmParameters(utmParameters || "");

        (0, _Location.getLocation)(function (location) {
          _this2.props.setLocation(location);
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // For Login Case
      if (this.props.auth.loggingIn && !nextProps.auth.loggingIn && nextProps.auth.loginError) {
        var errorResponse = nextProps.auth.loginError.response;
        if (!errorResponse) {
          this.props.changePopupType(_PopupType.PopupId.UnknownError);
        }
      }
    }
  }, {
    key: "getHeaderElement",
    value: function getHeaderElement(lang) {
      var element = null;
      if ((0, _NeutralBrandingRoutes.isNeutralBrandingRoute)(this.context.router.location.pathname)) {
        return _react2.default.createElement(
          "div",
          { className: _App2.default.logoHeader },
          _react2.default.createElement("img", { className: _App2.default.brandLogo, src: _logo_stingray2.default })
        );
      }
      var productName = this.props.auth.productName;
      var brandLogos = (0, _Product.getBrandLogos)(lang, this.props.auth.realm, productName, this.props.auth.clientId);
      var hasMobileHeader = !this.props.appInfo.excludeHeader && this.props.auth.isMobile;
      var hasBackButton = hasMobileHeader || productName === _Product.PRODUCT_NAMES.Qello;
      var backButtonVisible = hasBackButton && this.context.router.location.pathname.split("/").length > 2;
      var closeUrl = this.props.appInfo[productName] ? this.props.appInfo[productName].closeUrl : "";
      var hasCloseButton = productName === _Product.PRODUCT_NAMES.Qello && closeUrl;

      if (this.props.appInfo.excludeHeader) {
        element = null;
      } else if (this.isLeftAnchorLogo()) {
        element = _react2.default.createElement(
          "div",
          {
            className: _App2.default.logoHeader + " " + (hasMobileHeader ? _App2.default.mobileHeader : "") + " " + _App2.default.leftLogoHeader
          },
          _react2.default.createElement(
            "div",
            { className: _App2.default.logosContainer },
            brandLogos.map(function (brandLogo, index) {
              return _react2.default.createElement("img", { className: _App2.default.brandLogo, src: brandLogo, key: index });
            })
          ),
          productName === _Product.PRODUCT_NAMES.Music && !this.props.auth.isMobile && _react2.default.createElement(_components.LanguageDropdown, {
            className: _LanguageDropdown.lightGray + (this.props.hasHelp ? " " + _LanguageDropdown.helpClass : "")
          }),
          productName === _Product.PRODUCT_NAMES.Music && this.props.auth.realm && !this.props.auth.isMobile && _react2.default.createElement(_components.HelpButton, { className: _HelpButton.rightHelp })
        );
      } else {
        element = _react2.default.createElement(
          "div",
          {
            className: _App2.default.logoHeader + " " + (hasMobileHeader ? _App2.default.mobileHeader : "")
          },
          _react2.default.createElement(_components.BackButton, {
            className: _App2.default.back + " " + _App2.default.button + " " + (backButtonVisible ? _App2.default.visible : "")
          }),
          _react2.default.createElement(
            "div",
            { className: _App2.default.logosContainer },
            brandLogos.map(function (brandLogo, index) {
              return _react2.default.createElement("img", { className: _App2.default.brandLogo, src: brandLogo, key: index });
            })
          ),
          hasCloseButton ? _react2.default.createElement(_components.CloseButton, {
            className: _App2.default.close + " " + _App2.default.visible,
            closeUrl: closeUrl
          }) : _react2.default.createElement("div", { className: "" + _App2.default.button })
        );
      }
      return element;
    }
  }, {
    key: "getFooterElement",
    value: function getFooterElement() {
      if ((0, _NeutralBrandingRoutes.isNeutralBrandingRoute)(this.context.router.location.pathname)) {
        return null;
      }
      var element = null;
      var product = (0, _Product.getThemedProduct)(this.props.auth.productName, this.props.auth.clientId);
      if (product !== _Product.PRODUCT_NAMES.Music && product !== _Product.PRODUCT_NAMES.KaraokeTsm) {
        element = _react2.default.createElement(
          "div",
          { className: _App2.default.logo },
          _react2.default.createElement("img", { src: _stingray_logo_horizontal_white2.default })
        );
      }

      return element;
    }
  }, {
    key: "getScrollClassName",
    value: function getScrollClassName() {
      var popupType = this.props.type[0];
      var className = _App2.default.scroll;
      if (popupType) {
        className += " " + _App2.default.disableScroll;
      }

      return className;
    }
  }, {
    key: "isLeftAnchorLogo",
    value: function isLeftAnchorLogo() {
      return this.props.auth.productName === _Product.PRODUCT_NAMES.Music;
    }
  }, {
    key: "render",
    value: function render() {
      var isNeutralRoute = (0, _NeutralBrandingRoutes.isNeutralBrandingRoute)(this.context.router.location.pathname);
      var productClassName = isNeutralRoute ? "" : (0, _Product.getProductClassName)(this.props.auth.realm, this.props.auth.productName, this.props.auth.clientId);
      var lang = this.props.lang ? this.props.lang : _Language.defaultLanguage;

      var messages = (0, _Language.getLanguage)(this.props.auth.realm, this.props.auth.productName, lang).messages;
      var appElement = (0, _Product.getAppElementByProduct)(this.props.auth.realm, this.props.auth.productName, this.props.children);
      var headerElement = this.getHeaderElement(lang);
      var footerElement = this.getFooterElement();

      var backgroundCarouselImages = (0, _ImageRetriever.getBackgroundCarouselImages)(this.props.auth.productName);
      var backgroundStyle = {};
      var backgroundCarousel = null;

      if (isNeutralRoute) {
        backgroundStyle = {
          backgroundColor: "#F0F7FF",
          backgroundImage: "none"
        };
      } else if (backgroundCarouselImages && backgroundCarouselImages.length !== 0) {
        backgroundCarousel = _react2.default.createElement(_components.BackgroundCarousel, { images: backgroundCarouselImages });
      } else {
        var backgroundImg = (0, _Product.getBrandBackgroundImage)(lang, this.props.auth.realm, this.props.auth.productName, this.props.auth.clientId, this.props.auth.platform);
        if (backgroundImg) {
          backgroundStyle = {
            backgroundImage: "url(" + backgroundImg + ")"
          };
        }
      }

      return _react2.default.createElement(
        _reactIntl.IntlProvider,
        { defaultLocale: "en", locale: lang, messages: messages },
        _react2.default.createElement(
          "div",
          { className: [_App2.default.appContent, productClassName].filter(Boolean).join(" ") },
          _react2.default.createElement(
            "div",
            { className: this.getScrollClassName() },
            backgroundCarousel,
            _react2.default.createElement(
              "div",
              { className: _App2.default.background, style: backgroundStyle },
              _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
              headerElement,
              appElement,
              footerElement
            )
          ),
          _react2.default.createElement(_components.Popup, null)
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  changePopupType: _react.PropTypes.func,
  children: _react.PropTypes.object.isRequired,
  lang: _react.PropTypes.string,
  setUtmParameters: _react.PropTypes.func,
  setLocation: _react.PropTypes.func,
  type: _react.PropTypes.array
}, _class2.contextTypes = {
  store: _react.PropTypes.object.isRequired,
  router: _react2.default.PropTypes.object.isRequired
}, _temp)) || _class) || _class);
exports.default = App;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 1992
// module chunks = 0